// Hooks
import { useDesktopLogic } from 'app/shared/modules/MobileSRP/SeoFooter/useDesktopLogic';
import { useMobileLogic } from 'app/shared/modules/MobileSRP/SeoFooter/useMobileLogic';

export const useMarketingBlurb = (isDesktop = false) => {
  const marketingBlurbLogic = isDesktop ? useDesktopLogic : useMobileLogic;

  return marketingBlurbLogic();
};
